<template>
  <div>
    <lk-modal v-model="payModal" width='780' @on-visible-change='reset'>

      <p slot="header" class="modalHeader">

        <span class="mr8">收款信息</span>
        <!-- <lk-button type='primary' size='small' @click="showInsurance=!showInsurance">
          {{isInsuranceStr}}</lk-button> -->
      </p>

      <div class="payInfos">
        <div class="payInfoItem">
          <div class="title">总计</div>
          <div class="info">￥{{infos.totalAmount||0}}</div>
        </div>
        <div class="payInfoItem">
          <div class="title">折扣</div>
          <div class="discount">￥{{infos.discount||0}}</div>
        </div>
        <div class="payInfoItem">
          <div class="title">应收</div>
          <div class="info">￥{{infos.allPay||0}}</div>
        </div>
        <div class="payInfoItem" v-if="receiveVerificationAmount!==undefined">
          <div class="title">应收核销</div>
          <div class="info">￥{{receiveVerificationAmount}}</div>
        </div>
        <div class="payInfoItem">
          <div class="title">收银</div>
          <div class="info">￥{{infos.receive||0}}</div>
        </div>
        <div class="payInfoItem">
          <div class="title">待收</div>
          <div class="info">
            ￥{{toReceive}}</div>
        </div>
        <div class="payInfoItem">
          <div class="title">找零</div>
          <div class="info">
            ￥{{(infos.receive*1+(receiveVerificationAmount||0)-infos.allPay)>0?(infos.receive*1+(receiveVerificationAmount||0)-infos.allPay).toFixed(2):0}}</div>
        </div>

      </div>
      <div style="max-height:480px;overflow:auto" ref="payPart">
        <lk-form :label-width='110' ref="formValidate" :rules="ruleValidate" :model='formData'>
          <div v-if="showType && !isSFCollection && !orderInfo.hideTopInfo">
            <lk-form-item label='订单类型:' v-show="isShow">
              <lk-radio-group v-model="infos.type" class="radioGroup">
                <lk-radio :label='1' :disabled='!!orderInfo.type'>店销订单</lk-radio>
                <lk-radio :label='2' :disabled='!!orderInfo.type'>配送订单</lk-radio>
              </lk-radio-group>
            </lk-form-item>

            <div v-if="infos.type===2" class="deliveryInfo">
              <div class="deliveryText" v-show="isShow">配送信息:</div>
              <div class="deliveryContent">
                <div v-if="isShow">
                  <lk-form-item label='收货人姓名:' class="inputCon">
                    <span>
                      <lk-input v-if="orderInfo.notOrigin || orderInfo.sourceType === 0" v-model="saleExpress.name" placeholder="请输入">
                      </lk-input>
                      <span v-else>{{saleExpress.name}}</span>
                    </span>
                  </lk-form-item>
                  <lk-form-item label='联系方式:' class="inputCon">
                    <span>
                      <lk-input v-if="orderInfo.notOrigin || orderInfo.sourceType === 0" v-model="saleExpress.phone"
                        placeholder="请输入"></lk-input>
                      <span v-else>{{saleExpress.phone}}</span>
                    </span>
                  </lk-form-item>
                  <lk-form-item label='收货地址:' class="inputCon">
                    <span>
                      <lk-input v-if="orderInfo.notOrigin || orderInfo.sourceType === 0" v-model="saleExpress.address"
                        placeholder="请输入"></lk-input>
                      <span v-else>{{saleExpress.address}}</span>
                    </span>
                  </lk-form-item>
                  <lk-form-item label='配送方式:' class="inputCon" prop='deliveryMethod' v-if="showDelivery">
                    <span>
                        <lk-select
                          v-model="saleExpress.deliveryMethod"
                          placeholder="请选择"
                        >
                          <lk-option v-for="(item,index) in  deliveryMethodList" :key="index" :value='item.id'>{{item.name}}</lk-option>
                        </lk-select>
                      </span>
                  </lk-form-item>
                  <lk-form-item prop='name' label='发货人姓名:' class="inputCon">
                    <span>
                        <lk-select :disabled='noReceived'  v-model="saleExpress.consignor" filterable placeholder="请选择"
                          @on-change='handleUser'>
                          <lk-option v-for="(item,index) in  userList" :key="index" :value='item.id'>{{item.name+item.phone}}</lk-option>
                        </lk-select>
                        <!-- <lk-input v-model="" placeholder=""></lk-input> -->

                      </span>
                  </lk-form-item>
                  <lk-form-item label='发货人联系方式:' class="inputCon" prop='phone' >
                    <span>
                      <lk-input :disabled='noReceived' v-model="saleExpress.consignorPhone" placeholder="请输入" :maxlength='50'></lk-input>
                    </span>
                  </lk-form-item>
                  <lk-form-item label='配送公司:' class="inputCon">
                    <span>
                      <lk-input :disabled='noReceived'  v-model="saleExpress.company" placeholder="请输入"></lk-input>
                    </span>
                  </lk-form-item>
                  <div class="test" v-if="delivery">
                    <div class="expressItem">
                    <label>起运时间及温度：</label>
                    <span class="specItem">
                      <timeStampDatePicker :disabled='noReceived'  v-model="saleExpress.transStartTime"></timeStampDatePicker>
                      <numberInput  :disabled='noReceived' size='default' type='canMinus' v-model="base.temperatureStart"
                        placeholder="请输入">
                        <span>℃</span>
                      </numberInput>
                    </span>
                    </div>
                    <div class="expressItem" v-if="delivery">
                      <label>预计送达时间及温度：</label>
                      <span class="specItem">
                        <timeStampDatePicker :disabled='noReceived'  v-model="saleExpress.transEndTime"></timeStampDatePicker>
                        <numberInput size='default'  :disabled='noReceived' type='canMinus' v-model="base.temperatureEnd"
                          placeholder="请输入">
                          <span>℃</span>
                        </numberInput>
                      </span>
                    </div>
                  </div>
                  <lk-form-item label='配送单号:' class="inputCon">
                    <span>
                      <lk-input :disabled='noReceived' @on-change='handleValideLetterAndNumber($event,saleExpress.code)'
                        v-model="saleExpress.code" placeholder="请输入"></lk-input>
                    </span>
                  </lk-form-item>
                  <lk-form-item label='发货时间:' class="inputCon" prop='deliveryTime'>
                    <span>
                      <!-- <lk-input @on-change='handleValideLetterAndNumber($event,saleExpress.code)'
                        v-model="saleExpress.code" placeholder="请输入"></lk-input> -->
                      <timeStampDatePicker :disabled='noReceived'  v-model="saleExpress.expressTime"></timeStampDatePicker>
                    </span>
                  </lk-form-item>
                </div>
              </div>
            </div>
          </div>
            <div v-if="showInsurance" class="insurancePart">
              <ShaanXiProvincePayComp></ShaanXiProvincePayComp>
              <KunMingPayComp></KunMingPayComp>
            </div>
            <!-- 优惠卷开始 -->
          <div>
            <salesPromotion
              v-model="promotionInfo"
              ref="salePromotion"
              :orderInfo='orderInfo'
              :maxDiscount='maxDiscount'
              :storeId='storeInfo.id'
            />
          </div>
          <!-- 优惠卷结束 -->
          <lk-row :gutter="10" type='flex' v-if="isShowSfReceive">
            <lk-col span="7">
              <div style="display:flex;margin: 0 26px 0 46px;">
                <div style="margin:0 26px 16px 0;">配送代收:</div>
                <lk-switch v-model="isUseShunFengCollect" :disabled="sfDisabled" @on-change='handleChangeOfSFCollect'>
                  <lk-icon type="md-checkmark" slot="open"></lk-icon>
                  <lk-icon type="md-close" slot="close"></lk-icon>
                </lk-switch>
              </div>
            </lk-col>
            <lk-col span="10">
              <span class='sfTxt'>{{sfDisabledText ? sfDisabledText : '开启顺丰代收'}}</span>
            </lk-col>
          </lk-row>
          <div class="patientInfoOuterCon"  v-if="!showInsurance && !isSFCollection">
            <div class="patientInfo-first-line">
              <div style='margin: 0 26px 0 6px'>记为应收:</div>
              <lk-switch v-model="switchStatus" @on-change='handleSwitchChange' :disabled='orderInfo.sourceType != 0 || isCheckOrder || isOrderOfSF'>
                <lk-icon type="md-checkmark" slot="open"></lk-icon>
                <lk-icon type="md-close" slot="close"></lk-icon>
              </lk-switch>
              <div style='margin-left:30px' v-if="switchStatus">
                <div>应收款金额: {{toReceive}}</div>
              </div>
            </div>
            <div class="patientInfo-second-line" v-if="switchStatus">
              <lk-form-item prop='patientName' label='购药人姓名:' style='width:310px;'>
                <span>
                  <lk-input  v-model="formData.patientName" placeholder="请输入" :maxlength='32' :disabled='true'></lk-input>
                </span>
              </lk-form-item>
              <lk-form-item label='购药人联系方式:' class="" prop='patientPhone' style='width:310px; margin-left:26px'>
                <span>
                  <lk-input v-model="formData.patientPhone" placeholder="请输入" :maxlength='11' @on-blur='handlerBlur' :disabled='true'></lk-input>
                </span>
              </lk-form-item>
            </div>
          </div>
          <lk-form-item label="预收核销:" v-if="isHaveAdvancedReceive && !isSFCollection && !isUseShunFengCollect">
            <div class='infoList'>
              <div class='infoItem' style="display:flex" v-for="(item,index) in receiveAmountList" :key="index">
                <div>
                  <label><span>选择预收单：</span></label>
                  <lk-select class="depositItem" style="width: 200px" v-model="item.id" clearable>
                    <lk-option v-for="(deposit,i) in depositList" :value='deposit.id' :key="i" :disabled="isDisabled(deposit.id)">
                      {{deposit.createTime +' &nbsp; '+ deposit.deposit+'元&nbsp; '+deposit.paymentUserName +' &nbsp; '+ deposit.paymentUserPhone}}
                    </lk-option>
                  </lk-select>
                </div>
                <div style="display:flex;">
                  <label><span>核销金额：</span></label>
                  <NumberInput
                    type="canMinus"
                    :max="999999"
                    placeholder="收款金额"
                    style="width:90%"
                    size='large'
                    v-model="item.depositVerificationAmount"
                  ></NumberInput>
                  <lk-button
                    type="text"
                    size="small"
                    @click="toDeleteAReBill(index)"
                  >删除</lk-button>
                </div>
              </div>
              <lk-button type="text" @click="addNewReceiveBill">+新增预收单</lk-button>
            </div>
          </lk-form-item>
          <lk-form-item label="浦发POS收款:" v-if="!isHideAllReceive && isNeedPOSCollection && !isUseShunFengCollect">
            <div class='infoList'>
              <div class='infoItem' style="display:flex">
                <div>
                  <label><span>收款金额：</span></label>
                  <NumberInput
                    type="price"
                    :max="999999"
                    placeholder="收款金额"
                    style="width:100%"
                    @on-change='handleChange'
                    :disabled='orderInfo.completePOSCollection'
                    size=''
                    v-model="specialCollection.SPDBAmountList.amount"
                  ></NumberInput>
                </div>
              </div>
            </div>
            <div class="POS-tips">请在订单生成后使用浦发POS扫订单码(或输入单号)查询订单并完成收款</div>
          </lk-form-item>
          <lk-form-item label='收款类型:' v-if="!isHideAllReceive && !isUseShunFengCollect">
          <div class='infoList'>
            <div class='infoItem' v-for="(item,index) in paymentList" :key="index">
              <div>
                <label>
                  <span>{{item.proceedsTypeName+'：'}}</span>
                </label>
                <NumberInput
                  :type='item.proceedsTypeId===23?"canMinus":"price"'
                  size=''
                  @on-blur='handleBlur'
                  v-model="paymentList[index].amount"
                  :max='999999'
                  :disabled='([17,19].includes(item.proceedsTypeId)&&!!(orderInfo.insuranceId*1)) || ([29].includes(item.proceedsTypeId) && orderInfo.sourceType === 12)'
                  placeholder="收款金额"
                  style="width: 90%;"
                >
                </NumberInput>
              </div>
            </div>
            <div v-if="isSFCollection">
              <span class="iconfont alert">&#xe613;</span>
              <span>
                本功能仅用于无法扫码收款的代收订单，确认收款后将视为订单代收完成，请仔细核对收款信息!
              </span>
              <br>
              <span class='infoTips'>
                如现金收款，请点清钱款;如浦发pos收款，请确认收款小票金额正确。
              </span>
            </div>
          </div>
          </lk-form-item>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button @click="cancel">取消</lk-button>
        <lk-button type='primary' :loading='payLoading' @click="validate">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NumberInput from './NumberInput';
import timeStampDatePicker from '../timeStampDatePicker';
import system from '../../services/system.js';
import sale from '../../services/sale.js';
import utils from '../../libs/utils';
import salesPromotion from './salesPromotion.vue';
import ShaanXiProvincePayComp from '../insurance/ShaanXiProvincePayComp.vue';
import KunMingPayComp from '../insurance/KunMingPayComp.vue';
import storeUtils from '../../libs/storeUtil';

export default {
  name: 'paymentModal',
  // mixins: [mapState],
  components: {
    NumberInput,
    timeStampDatePicker,
    ShaanXiProvincePayComp,
    salesPromotion,
    KunMingPayComp,
  },
  props: {
    base: {},
    delivery: {
      type: Boolean,
      default: false,
    },
    isCheckOrder: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: true,
    },
    orderInfo: {
      type: Object,
    },
    paidList: {
      type: Array,

    },
    value: {
      type: Boolean,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    showType: {
      type: Boolean,
      default: !false,
    },
    receiveVerificationAmount: {
      type: Number,

    },
    patientInfo: {
      type: Object,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    sfDisabled: {
      type: Boolean,
      default: false,
    },
    sfDisabledText: {
      type: String,
    },
    isShowSfReceive: {
      type: Boolean,
      default: false,
    },
    isOrderOfSF: { // 配送方式如果是顺丰，不能选择应收
      type: Boolean,
      default: false,
    },
    saleOrderDetailList: {
      type: Array,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  watch: {
    patientInfo: {
      handler(val) {
        this.formData.patientName = val.relatePatientName;
        this.formData.patientPhone = val.relatePatientPhone;
      },
      deep: true,
    },
    orderInfo: {
      handler(val) {
        // pos收款赋默认值
        if (val.tag === 2) {
          this.specialCollection.SPDBAmountList.amount = val.receivablesAmount;
        }
        this.infos.allPay = utils.fixNumber(val.payment, 2);
        this.infos.totalAmount = utils.fixNumber(val.totalAmount, 2);
        this.infos.discount = utils.fixNumber(val.discount, 2);
        this.infos.allCount = val.goodsCount;
        const { promoteDiscountVOList } = this.orderInfo;
        this.infos.tempDiscount = val.discount;
        // tempDiscount 怎么取：如果有其他折扣，取discount - 其他折扣
        // 如果没有就取discount
        if (promoteDiscountVOList && promoteDiscountVOList.length > 0) {
          promoteDiscountVOList.forEach((item) => {
            if (item.remark) {
              this.infos.tempDiscount = val.discount - Number(item.cutPrice); // 计算除去其他折扣金额的最大优惠金额
            }
          });
        }
        const { tempDiscount, totalAmount } = this.infos;
        if (tempDiscount > 0) {
          this.maxDiscount = Number(totalAmount) - tempDiscount;
        } else {
          this.maxDiscount = Number(totalAmount);
        }
      },
      deep: true,
    },
    promotionInfo: {
      handler(val) {
        const { tempDiscount, totalAmount } = this.infos;
        this.infos.discount = (Number(tempDiscount) + Number(val.promotionDiscount || 0)).toFixed(2);
        this.infos.allPay = (Number(totalAmount) - this.infos.discount).toFixed(2);
      },
      deep: true,
    },
    payModal(val) {
      this.$emit('change', val);
    },
    value(val) {
      this.payModal = val;
      if (val) {
        if (this.saleOrderDetailList && this.saleOrderDetailList.length) {
          const goodsBaseIdList = this.saleOrderDetailList.map(item => item.goodsBaseId);
          this.getPaymentList(goodsBaseIdList);
        }
        this.switchStatus = this.orderInfo.switchStatus;
        if (this.switchStatus) {
          this.formData.patientName = this.orderInfo.patientName || '';
          this.formData.patientPhone = this.orderInfo.patientPhone || '';
          this.handleSwitchChange();
        }
        this.getDepositList().then(() => {
          this.depositList = utils.deepClone(this.OriginDepositList);
          const receiveCodes = this.orderInfo.receiveFinanceDepositList && this.orderInfo.receiveFinanceDepositList.map(item => item.depositCode);
          this.depositList = this.depositList.filter(item => !receiveCodes || !receiveCodes.includes(item.depositCode));
          console.log(receiveCodes);
          this.$nextTick(() => {
            if (this.orderInfo.receiveAmountList && this.orderInfo.receiveAmountList.length) {
              this.orderInfo.receiveAmountList.forEach((orderInfoItem) => {
                orderInfoItem.createTime = utils.formatDate(orderInfoItem.createTime);
                const index = this.depositList.findIndex(deposit => deposit.id === orderInfoItem.id);
                if (index < 0) {
                  orderInfoItem.deposit = orderInfoItem.depositVerificationAmount;
                  this.depositList.push(orderInfoItem);
                } else {
                  this.depositList[index].deposit += orderInfoItem.depositVerificationAmount;
                }
                this.receiveAmountList = this.orderInfo.receiveAmountList;
              });
            }
          });
          if (this.paidList && this.paidList.length) { // paidList是在收银台付款时用的哪些收款方式和收款金额等收款信息
            this.paidList.forEach((paid) => {
              this.paymentList.forEach((item) => {
                if (item.proceedsTypeId === paid.proceedsTypeId) { // 找到那些收款方式，将在收银台填写的金额赋值到收款框里。
                  item.amount = paid.amount;
                }
              });
            });
          } else {
            this.paymentList.forEach((item) => { item.financeDepositId = null; });
          }
          this.handleChange();
        });
      } else {
        this.receiveAmountList = [{}];
      }
      // val && (this.paymentList = this.paidList);
    },
    paymentList: {
      handler(val) {
        console.log(val);
        if (this.paidList && this.paidList.length) { // paidList是在收银台付款时用的哪些收款方式和收款金额等收款信息
          this.paidList.forEach((paid) => {
            this.paymentList.forEach((item) => {
              if (item.proceedsTypeId === paid.proceedsTypeId) { // 找到那些收款方式，将在收银台填写的金额赋值到收款框里。
                item.amount = paid.amount;
              }
            });
          });
        } else {
          this.paymentList.forEach((item) => { item.financeDepositId = null; });
        }
        this.handleChange();
      },
      deep: true,
    },
    receiveAmountList: {
      handler() {
        this.handleChange();
      },
      deep: true,
    },
  },
  computed: {
    isNeedPOSCollection() {
      return storeUtils.isNeedPOSCollection(this.$store.state.storeInfo.id) && !this.isSFCollection;
    },
    isSFCollection() {
      return this.orderInfo.isCollection;
    },
    showDelivery() {
      return this.routeList.includes(this.$route.name) && [10, 13].indexOf(this.orderInfo.sourceType) >= 0;
    },
    isInsuranceStr() {
      return this.showInsurance ? '切换普通收款' : '切换医保收款';
    },
    noReceived() {
      return this.saleExpress.received === 2;
    },
    toReceive() { // 待收
      return (this.infos.allPay * 1 - this.infos.receive * 1 - (this.receiveVerificationAmount || 0)) > 0 ? (this.infos.allPay - this.infos.receive - (this.receiveVerificationAmount || 0)).toFixed(2) : 0;
    },
    ...mapState({
      storeInfo: state => state.storeInfo,
      publicParams: state => state.publicParams,
    }),
    isHaveAdvancedReceive() { // 判断门店收款方式中是否有预收款
      const obj = this.paymentListCopyed.find(item => item.proceedsTypeId === 6);
      if (obj && !this.switchStatus) {
        return true;
      }
      return false;
    },
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!this.saleExpress.consignor) {
        callback(new Error('请选择发货人'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!this.saleExpress.consignorPhone) {
        callback(new Error('请填写发货人联系方式'));
      } else {
        const phone = [/^1[3465789]\d{9}$/, /^0\d{2,3}-?\d{7,8}$/, /^0\d{2,3}\s?\d{7,8}$/];
        let ifsuccess = false;
        phone.forEach((item, index) => {
          if (item.test(this.saleExpress.consignorPhone)) {
            ifsuccess = true;
          }
          // else {
          //   callback(new Error('请按照标准填写联系方式'));
          // }
        });
        ifsuccess ? callback() : callback(new Error('请输入手机号码或包含区号的固定电话号码'));
      }
    };
    const validateDeliveryTime = (rule, value, callback) => {
      if (!this.saleExpress.expressTime) {
        callback(new Error('请选择发货时间'));
      } else {
        callback();
      }
    };
    return {
      sfTransport: 'SF-CITYRUSH',
      isUseShunFengCollect: false,
      specialCollection: { // 抽离出来的特殊收款集合
        SPDBAmountList: {
          amount: null,
          proceedsTypeId: 55, // 浦发银行POS
        },
      },
      isHideAllReceive: false, // 是否隐藏所有的收款框
      receiveAmountList: [ // 默认展示一条数据
        {},
      ],
      paymentListCopyed: [], // 备份一套收款类型数据
      switchStatus: false, // 记为应收状态
      routeList: ['OTCOrderSale', 'prescriptionSale'],
      deliveryMethodList: [ // 配送方式
        {
          id: 1,
          name: '自配送',
        },
        {
          id: 4,
          name: '菜鸟-顺丰',
        },
        {
          id: 3,
          name: '其他',
        },
      ],
      promotionInfo: {}, // 其他折扣
      promoteDiscountVOList: [], // 折扣信息
      maxDiscount: 0, // 其他折扣金额最大值
      formData: {
        name: '',
        phone: '',
        deliveryMethod: 4,
        patientName: null,
        patientPhone: null,
      },
      OriginDepositList: [],
      curPatientInfo: {
        patientName: '',
        patientPhone: '',
      },
      depositList: [],
      showInsurance: false,
      showExpress: false,
      saleExpress: {},
      type: null,
      payLoading: false,
      paymentList: [],
      infos: {
        allPay: 0,
        allCount: 0,
        receive: 0,
        totalAmount: 0,
        discount: 0,
        type: null,
        tempDiscount: 0, // 暂存除去其他折扣金额的优惠总计
      },
      payModal: false,
      userList: [],
      filtedList: [],
      ruleValidate: {
        name: [
          { required: true, validator: validateName, trigger: 'change' },
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'change' },
        ],
        deliveryTime: [
          { required: true, validator: validateDeliveryTime, trigger: 'change' },
        ],
        deliveryMethod: [
          {
            required: true, message: '请选择配送方式', trigger: 'change', type: 'number',
          },
        ],
        patientName: [],
        patientPhone: [],
      },
    };
  },
  methods: {
    handleAmountValidate() {
      let validate = true;
      this.receiveAmountList.forEach((item) => {
        if (item.depositVerificationAmount && !item.id) {
          this.$Message.error('请检查预收信息填写是否正确');
          validate = false;
        }
        if (item.id && item.depositVerificationAmount === 0) {
          this.$Message.error('请输入预收核销金额');
          validate = false;
        }
        if (item.id) {
          const obj = this.depositList.find(item1 => item1.id === item.id);
          if (!obj) {
            this.$Message.error('数据错误');
            validate = false;
          }
          if (item.depositVerificationAmount > obj.deposit) {
            this.$Message.error('预收核销金额超出预收单剩余金额');
            validate = false;
          }
        }
      });
      return validate;
    },
    isDisabled(value) {
      const obj = this.receiveAmountList.find(item => item.id === value);
      if (obj) {
        return true;
      }
      return false;
    },
    addNewReceiveBill() {
      if (this.receiveAmountList.length >= 5) {
        this.$Message.error('最多添加5条预收单');
        return;
      }
      this.receiveAmountList.push({});
    },
    toDeleteAReBill(index) {
      if (this.receiveAmountList.length <= 1) {
        this.$Message.error('不可删除');
        return;
      }
      this.receiveAmountList.splice(index, 1);
    },
    compareIfSamePatient() {
      if (this.switchStatus) {
        if (this.validateAllSelReceiveBill() && this.receiveAmountList.length) {
          const id = this.receiveAmountList[0].id;
          const obj = this.findADeposit(id);
          if (obj) {
            const { paymentUserName, paymentUserPhone } = obj;
            if (paymentUserName !== this.formData.patientName || paymentUserPhone !== this.formData.patientPhone) {
              this.$Message.error('应收款和预收款关联购药人信息不同，请检查后重新提交');
              return false;
            }
          }
          return true;
        }
      } else {
        return this.validateAllSelReceiveBill();
      }
    },
    validateAllSelReceiveBill() {
      if (this.receiveAmountList.length <= 0) {
        return true;
      }
      let validate = true;
      this.receiveAmountList.forEach((item1) => {
        this.receiveAmountList.forEach((item2) => {
          const objf = this.findADeposit(item1.id);
          const objsecond = this.findADeposit(item2.id);
          if (objf && objsecond) {
            if (objf.paymentUserName !== objsecond.paymentUserName || objsecond.paymentUserPhone !== objf.paymentUserPhone) {
              validate = false;
            }
          }
        });
      });
      if (!validate) {
        this.$Message.error('预收单应为同一人');
      }
      return validate;
    },
    findADeposit(ID) {
      const obj = this.depositList.find(item => item.id === ID);
      return obj;
    },
    handleChangeOfSFCollect() {
      if (this.isUseShunFengCollect) {
        this.specialCollection.SPDBAmountList.amount = null;
        this.paymentList.forEach((item) => {
          item.amount = null;
        });
        this.receiveAmountList.forEach((item) => {
          item.depositVerificationAmount = null;
        });
        this.handleChange();
      }
    },
    handleSwitchChange() {
      if (this.switchStatus) {
        this.specialCollection.SPDBAmountList.amount = null;
        this.paymentList.forEach((item) => {
          item.amount = null;
        });
        this.receiveAmountList.forEach((item) => {
          item.depositVerificationAmount = null;
        });
        this.handleChange();
        this.isHideAllReceive = true;
        this.ruleValidate.patientName = [
          {
            required: true,
            message: '请输入购药人',
            trigger: 'change',
          },
        ];
        this.ruleValidate.patientPhone = [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入联系方式'));
              } else if (value.length !== 11) {
                callback(new Error('请输入有效的联系方式'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ];
      } else {
        this.isHideAllReceive = false;
        this.ruleValidate.patientName = [];
        this.ruleValidate.patientPhone = [];
      }
    },
    validate() {
      if (this.isUseShunFengCollect) {
        this.handleClick();
        return;
      }
      if (!this.compareIfSamePatient()) {
        return;
      }
      if (!this.switchStatus) {
        if (this.toReceive !== 0) {
          this.$Message.error('请输入正确的收款金额');
          return;
        }
      }
      if (this.switchStatus) {
        this.curPatientInfo.patientPhone = this.formData.patientPhone;
        this.curPatientInfo.patientName = this.formData.patientName;
      }
      if (this.isSFCollection) {
        this.handleClick();
      } else {
        this.$refs.salePromotion.validateForm().then((valid) => {
          if (!valid) {
            return;
          }
          if (this.infos.type == 1 && this.switchStatus) {
            this.$refs.formValidate.validateField('patientName', (msg1) => {
              this.$refs.formValidate.validateField('patientPhone', (msg2) => {
                if (!msg1 && !msg2) {
                  this.handleClick();
                }
              });
            });
          } else if (this.infos.type == 1 && !this.switchStatus) {
            this.handleClick();
          }
          // 销售订单的收款没有配送信息
          if (!this.orderInfo.hideTopInfo) {
            if (this.infos.type == 2) { // 判断订单为配送订单
              if (!this.isShow) {
                this.handleClick();
              } else {
                this.$refs.formValidate.validate((valid) => {
                  if (!valid) {
                    this.$Message.error('请按照要求填写');
                  } else {
                    this.handleClick();
                  }
                });
              }
            }
          } else {
            this.handleClick();
          }
        });
      }
    },
    handleValideLetterAndNumber(e, str) {
      // const str = e.target.value;
      const val = e.data;
      console.log(e);
      console.log(str);
      const reg = /([a-z]|[A-Z]|\d)/;
      if (!reg.test(val)) {
        console.log(val);
        const valReg = /[^a-zA-Z0-9]/g;
        this.$nextTick(() => {
          this.saleExpress.code = this.saleExpress.code.replace(valReg, '');
        });
      }
    },
    handlerBlur() {
      const num = this.formData.patientPhone;
      this.formData.patientPhone = num && num.replace(/[^\d]/g, '');
    },
    handleChange() {
      // this.infos.receive = 0;
      let res = 0;
      this.paymentList.forEach((item) => {
        res += (item.amount * 1 || 0);
      });
      let num = 0;
      this.receiveAmountList.forEach((item) => {
        if (item.depositVerificationAmount) {
          num += item.depositVerificationAmount * 1;
        }
      });
      res += num * 1;
      res += (this.specialCollection.SPDBAmountList.amount || 0) * 1;
      // debugger;
      this.$set(this.infos, 'receive', utils.fixNumber(res, 2).toFixed(2));
    },
    cancel() {
      this.payModal = false;
      this.$emit('change', false);
      this.paymentList.forEach((item) => {
        item.amount = null;
      });
      this.$refs.salePromotion.reset();
    },
    handleClick: utils.debounce(
      function a() {
        if (this.showType && !this.infos.type) {
          this.$Message.error('请选择订单类型');
          return;
        }

        let cashNum = 0;
        let allAmount = this.receiveVerificationAmount || 0;
        this.paymentList.forEach((item) => {
          if (item.proceedsTypeId === 2 && item.amount) {
            cashNum = item.amount;
          }
          allAmount += item.amount * 1;
        });
        this.receiveAmountList.forEach((item) => {
          allAmount += (item.depositVerificationAmount || 0) * 1;
        });
        allAmount += this.specialCollection.SPDBAmountList.amount * 1;
        if (this.infos.type === 1) {
          if (!this.infos.receive) {
            this.$Message.error('请输入收款金额');
            return;
          }
        }
        if (this.orderInfo.isCollection) {
          if (allAmount && (allAmount.toFixed(2) * 1) !== this.infos.allPay * 1) {
            this.$Message.error('请输入正确的收款金额');
            return;
          }
        }
        if (!this.switchStatus && !this.isUseShunFengCollect) { // 开启预收或者顺丰代收的时候不验证收款金额
          if ((this.infos.receive * 1 + (this.receiveVerificationAmount || 0)) < (this.infos.allPay * 1)) {
            this.$Message.error('实收金额小于应收价格请修改价格。');
            return;
          }

          if (!cashNum && allAmount && (allAmount.toFixed(2) * 1) !== this.infos.allPay * 1) {
            this.$Message.error('非现金支付请收取正确钱款');

            return;
          }
          if (cashNum && cashNum <= (this.infos.receive - this.infos.allPay)) {
            this.$Message.error('现金支付请收取正确钱款');
            return;
          }
        }
        if (this.infos.type === 2 && this.delivery && (this.saleExpress.transStartTime > this
          .saleExpress.transEndTime) && !this.orderInfo.hideTopInfo) {
          this.$Message.error('请填写正确运送时间');

          return;
        }
        if (!this.handleAmountValidate()) {
          return;
        }
        this.$emit('submitPay', this.paymentList, this.infos, this.saleExpress, this.base, this.curPatientInfo, this.promotionInfo, this.receiveAmountList, this.specialCollection, this.isUseShunFengCollect);
      }, 1000,
    ),
    handleBlur() {
      this.handleChange();
    },
    getPaymentList(goodsBaseIdList) {
      const params = {
        status: 1,
      };
      if (goodsBaseIdList) {
        params.goodsBaseIdList = goodsBaseIdList;
      }
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList(params).then((res) => {
          if (res.data.status === 200) {
            this.paymentList = res.data.data.list;
            this.paymentListCopyed = utils.deepClone(this.paymentList);
            this.paymentList = this.paymentList.filter(item => item.proceedsTypeId !== 6);
            this.paymentList.forEach((item) => {
              item.amount = null;
            });

            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getUserList() {
      system.storeUserList({
        page: 1,
        size: 100,
        statusCodeList: [1],
      }).then((res) => {
        if (res.data.status === 200) {
          this.userList = [];
          res.data.data.list.forEach((item) => {
            const temp = {
              id: item.sysUser.id,
              name: item.sysUser.name,
              phone: item.sysUser.phone,
            };
            this.userList.push(temp);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleUser(val) {
      let temp = null;
      this.userList.forEach((item) => {
        if (item.id === val) {
          temp = item;
        }
      });
      this.saleExpress.consignorPhone = temp.phone;
      this.saleExpress.consignorName = temp.name;
    },

    reset(isShow) {
      if (isShow) {
        // this.infos = this.orderInfo;
        // utils.toFixed(this.orderInfo.payment,2)

        this.infos.allPay = utils.fixNumber(this.orderInfo.payment, 2).toFixed(
          2,
        ); // this.orderInfo.payment;
        this.infos.allCount = utils.fixNumber(this.orderInfo.goodsCount, 2).toFixed(2);
        if (this.infos.discount !== 0) {
          this.infos.totalAmount = utils.fixNumber(this.orderInfo.totalAmount, 2).toFixed(2);
          this.infos.discount = utils.fixNumber(this.orderInfo.discount, 2).toFixed(2);
        }
        this.infos.type = this.orderInfo.type || 1;
        this.saleExpress = utils.deepClone(this.orderInfo.saleExpress) || {};
        // 顺丰代收的只留现金收款 2 ，浦发POS收款 55
        const tempPaymentList = [];
        if (this.orderInfo.isCollection) {
          this.publicParams.SFCollectionType.showSFCollectionList.forEach((id) => {
            const collectionType = this.paymentListCopyed.find(item => item.proceedsTypeId == id);
            collectionType && tempPaymentList.push(collectionType);
          });
          this.paymentList = tempPaymentList;
        }
        const {
          saleExpress,
          sourceType,
        } = this.orderInfo;
        this.saleExpress = utils.deepClone(saleExpress) || {};
        if (sourceType && [10].indexOf(sourceType) >= 0) {
          this.saleExpress.deliveryMethod = 4; // 天猫订单默认菜鸟顺丰
        } else if (sourceType && [13].indexOf(sourceType) >= 0) {
          this.saleExpress.deliveryMethod = 1; // 京东默认配送自配送
        }
        // this.handleType(this.infos.type);
        this.handleChange();
      } else {
        setTimeout(() => {
          this.infos.type = null;
          // this.userId = null;
          this.paymentList.forEach((item) => {
            item.amount = null;
          });
          this.switchStatus = false;
          this.handleSwitchChange();
          this.specialCollection.SPDBAmountList.amount = null;
        }, 500);
      }
    },
    getDepositList() {
      return new Promise((resolve) => {
        sale.getExistReceivablesList().then((res) => {
          this.depositList = res;
          this.depositList.forEach((item) => {
            item.createTime = utils.formatDate(item.createTime);
          });
          this.OriginDepositList = utils.deepClone(this.depositList);// 处理数据暂存问题
          resolve();
        });
      });
    },
  },
  created() {
    this.getUserList();
    this.getPaymentList();
  },
  mounted() {
  },
};

</script>
<style lang="less" scoped>
.patientInfoOuterCon {
  .patientInfo-first-line {
    display: flex;
    align-items: center;
    padding-left: 40px;
    margin-bottom: 10px;
  }
  .patientInfo-second-line {
    margin-left: 100px;
    display: flex;
    align-items: center;
  }
}
.inputCon {
  width: 400px;
}
  .modalHeader {
    height: 28px;
    display: flex;
    align-items: center
  }

  .infoList {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 24px;

    .infoItem>div {
      display: flex;
      width: 300px;
      margin-bottom: 8px;

      // img {
      //   width: 16px;
      //   height: 16px;
      //   margin-right: 8px;
      // }

      label {
        width: 100px;
        text-align: left;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        justify-content: flex-end;

        span {
          flex-shrink: 0
        }
      }

    }
  }

  .payInfos {
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dedede;

    // align-items: center;
    .payInfoItem {
       width: 120px;
      .info {
        font-size: 18px;
        color: rgba(46, 46, 46, 0.85);
        font-weight: 500
      }
      .discount {
        font-size: 18px;
        color: red;
        font-weight: 500
      }
    }
  }

  .expressItem {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .specItem {
      display: flex;

      >* {
        width: 50%;
        flex-shrink: 0
      }
    }

    >* {
      flex-shrink: 0
    }

    >span {
      width: 300px;
    }

    label {
      width: 120px;
      text-align: right;
    }
  }
.deliveryInfo {
  margin-left: 40px;
  margin-bottom: 20px;
  display: flex;
    .deliveryText {
      margin-left: 6px;
      margin-top: 7px;
      width: 60px;
      height: 30px;
      display: flex;
    }
}
.test {
  margin-left: -10px;
}
.deliveryContent {
  display: inline-block;
}
.radioGroup {
  margin-left: 12px;
}
.alert {
  color: rgb(233,157,66);
}
.infoTips {
  margin-left: 20px;
}
.POS-tips {
  padding-left: 20px;
  color: #808080;
}
</style>
